import { BookOpen } from 'lucide-react'
import { cn } from '@/utils/cn'
import { getLocalizedValue } from '@sakeena/shared'
import { useTranslation } from 'react-i18next'

export interface Category {
  id: string
  name: any
  nameEn?: string
  icon?: string
  order?: number
}

interface CategorySidebarProps {
  categories: Category[]
  selectedCategory: string | null
  onCategorySelect: (categoryId: string | null) => void
}

export default function CategorySidebar({
  categories,
  selectedCategory,
  onCategorySelect,
}: CategorySidebarProps) {
  const { i18n } = useTranslation()
  const currentLang = i18n.language || 'ar'

  return (
    <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-200">
      <h3 className="font-bold text-gray-900 mb-4">الأقسام</h3>
      <div className="space-y-1">
        <button
          onClick={() => onCategorySelect(null)}
          className={cn(
            'w-full text-right px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-2',
            selectedCategory === null
              ? 'bg-primary-100 text-primary-700'
              : 'text-gray-700 hover:bg-gray-100'
          )}
        >
          <BookOpen className="w-4 h-4" />
          <span>الكل</span>
        </button>
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategorySelect(category.id)}
            className={cn(
              'w-full text-right px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-2',
              selectedCategory === category.id
                ? 'bg-primary-100 text-primary-700'
                : 'text-gray-700 hover:bg-gray-100'
            )}
          >
            <BookOpen className="w-4 h-4" />
            <span>{getLocalizedValue(category.name, currentLang)}</span>
            {category.nameEn && typeof category.name === 'string' && (
              <span className="text-xs text-gray-500">({category.nameEn})</span>
            )}
          </button>
        ))}
      </div>
    </div>
  )
}
